import React, { Component } from 'react';

import { T } from '../../../../../../common/locale/translate';
import Table from '../../../../common/components/responsive-table';
import {
  get_upgrades_data,
  filterParameters,
  isDesktopDevice
} from '../../../../services/services';

import HotelUpgrade from './upgrade';

export default class HotelUpgradesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upgrades_data: [],
      active: false,
      isOpen: false,
      headers: {
        desktop: [
          { name: 'accommodation', title: T('accommodation') },
          { name: 'alimentation', title: T('board') },
          { name: 'suplement', title: T('price_quality') }
        ],
        mobile: [
          { name: 'suplement_mobile', title: T('price_quality') },
          { name: 'accommodation', title: T('accommodation') },
          { name: 'alimentation', title: T('board') },
          { name: 'action_button_mobile', title: '' }
        ]
      },
      mobile_display_limit: 2,
      display_limit: 3,
      mobile_current_display_limit: 2,
      current_display_limit: 3,
      more_button_text: T('more_options')
    };
  }

  componentDidMount() {
    const params = this.hotelUpgradesParams();
    get_upgrades_data(params)
      .then(response => {
        if (
          response.status !== 204 &&
          response.data &&
          response.data.variants_list
        ) {
          this.setState({
            active: true,
            upgrades_data: response.data.variants_list,
            display_limit:
              response.data.variants_list.length < this.state.display_limit
                ? response.data.variants_list.length
                : this.state.display_limit
          });
        }
      })
      .catch(err => {
        console.log(`Error: ${err}`);
      });
  }

  render() {
    let headers = isDesktopDevice()
        ? this.state.headers.desktop
        : this.state.headers.mobile,
      limit = isDesktopDevice() ? '' : 'mobile_',
      display_limit = this.state[`${limit}current_display_limit`];
    display_limit =
      this.state.upgrades_data.length < display_limit
        ? this.state.upgrades_data.length
        : display_limit;
    return (
      <div className={`hotel-upgrades ${this.state.active ? 'active' : ''}`}>
        <h3 className="hotel-upgrades-title">
          {T('other_accommodation_options')}
        </h3>
        <section className="upgrades">
          <Table headers={headers}>
            {this.state.upgrades_data.length &&
              Array.apply(null, Array(display_limit)).map((index, i) => {
                const data = this.state.upgrades_data[i];
                return (
                  <HotelUpgrade
                    data={data}
                    key={i}
                    className={data.name}
                    params={this.props.params}
                  />
                );
              })}
          </Table>
          {this.state.upgrades_data.length > this.state.display_limit && (
            <div className="see-more-button-wrapper">
              <span
                className="see-more-button"
                onClick={this.expandHotelUpgrades.bind(this, limit)}
              >
                {this.state.more_button_text}
                <i
                  className={`fa ${
                    this.state.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'
                  }`}
                />
              </span>
            </div>
          )}
        </section>
      </div>
    );
  }

  expandHotelUpgrades(limit) {
    const open = this.state.isOpen;
    this.setState({
      isOpen: !open,
      [`${limit}current_display_limit`]: !open
        ? this.state.upgrades_data.length
        : this.state[`${limit}display_limit`],
      more_button_text: !open ? T('less_options') : T('more_options')
    });
  }

  hotelUpgradesParams() {
    const allowed_params = [
      'adults_number',
      'children_ages',
      'offer_type',
      'departure_date',
      'return_date',
      'offer_id',
      'parser'
    ];
    return filterParameters(this.props.params, allowed_params);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/upgrades/index.js